<template>
  <div
    class="h-[28px] flex gap-1.5 text-brand-secondary text-style-sm font-medium bg-utility-brand-50_alt items-center overflow-hidden rounded-md pr-2"
  >
    <div
      class="bg-utility-brand-100_alt px-1.5 flex justify-center items-center h-full rounded-md"
    >
      {{ name }}
    </div>
    <div class="flex gap-1 items-center">
      <span>
        {{ text }}
      </span>
      <Icon name="close" size="xs" @click="emit('remove')" @click.stop />
    </div>
  </div>
</template>

<script setup>
import { Icon } from "@/SharedComponents/Icon";

const emit = defineEmits(["remove"]);

defineProps({
  name: {
    type: String,
    required: true,
  },
  text: {
    type: String,
    required: true,
  },
});
</script>
